import { createFileRoute } from '@tanstack/react-router';
import { EventForm } from '../../pages/EventForm';
import { useEvent } from '@/lib/hooks/useEvents';
import { Header } from '../../components/Header';
import { requireAdminRoute } from '@/lib/utils/route-auth.utils';

export const Route = createFileRoute('/_authenticated/events/$eventId/edit')({
  beforeLoad: ({ context }) => requireAdminRoute(context),
  component: EditEventPage,
});

function EditEventPage() {
  const { eventId } = Route.useParams();
  const eventIdNum = parseInt(eventId, 10);

  const { data: event, isLoading, error } = useEvent(eventIdNum);

  if (isLoading) {
    return (
      <>
        <Header enableBack additionalClasses="bg-slate-600" />
        <div className="flex justify-center items-center py-12">
          <p className="text-body text-foreground/60">Loading event...</p>
        </div>
      </>
    );
  }

  if (error || !event) {
    return (
      <>
        <Header enableBack additionalClasses="bg-slate-600" />
        <div className="flex justify-center items-center py-12">
          <p className="text-body text-foreground/60">
            {error ? 'Failed to load event' : 'Event not found'}
          </p>
        </div>
      </>
    );
  }

  return <EventForm mode="edit" eventId={eventIdNum} />;
}
